@use '~/vendor/cxy/scss/styles/index.scss' as cxy;

.formRefinementContainer {
  @include cxy.stack(var(--cxy-spacing-xxsm));
}

.label {
  font-size: var(--cxy-fontSize-s);
  margin-top: var(--cxy-spacing-xxsm);
}

.resetButton {
  align-self: center;
}
